/** Short weekday label i18n keys. */
export const WEEKDAY_SHORT_LABEL_KEYS = [
	'layout.calendar.weekdays_short.sunday',
	'layout.calendar.weekdays_short.monday',
	'layout.calendar.weekdays_short.tuesday',
	'layout.calendar.weekdays_short.wednesday',
	'layout.calendar.weekdays_short.thursday',
	'layout.calendar.weekdays_short.friday',
	'layout.calendar.weekdays_short.saturday',
] as const;
